
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("3GL6j"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("3GL6j", function(module, exports) {

let $2af9d490fec23a54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2af9d490fec23a54$var$load("h3ABO"),
    $2af9d490fec23a54$var$load("LVAZY"),
    $2af9d490fec23a54$var$load("fSobj"),
    $2af9d490fec23a54$var$load("74u2y"),
    $2af9d490fec23a54$var$load("2YffH"),
    $2af9d490fec23a54$var$load("1aTst"),
    $2af9d490fec23a54$var$load("6mHrv"),
    $2af9d490fec23a54$var$load("awWN9"),
    $2af9d490fec23a54$var$load("9CYct"),
    $2af9d490fec23a54$var$load("iIoyG"),
    $2af9d490fec23a54$var$load("2xn4F"),
    $2af9d490fec23a54$var$load("hZtKG"),
    $2af9d490fec23a54$var$load("iNmaF"),
    $2af9d490fec23a54$var$load("lVO3w"),
    $2af9d490fec23a54$var$load("hyzoX"),
    $2af9d490fec23a54$var$load("h9Ed7"),
    $2af9d490fec23a54$var$load("eBRUf"),
    $2af9d490fec23a54$var$load("b2zxR"),
    $2af9d490fec23a54$var$load("tKhaz"),
    $2af9d490fec23a54$var$load("9ScqF"),
    $2af9d490fec23a54$var$load("1glxT"),
    $2af9d490fec23a54$var$load("cD6Zr"),
    $2af9d490fec23a54$var$load("dtASV"),
    $2af9d490fec23a54$var$load("8A3nE"),
    $2af9d490fec23a54$var$load("8YSo7"),
    $2af9d490fec23a54$var$load("g7ggm"),
    $2af9d490fec23a54$var$load("Wowvf"),
    $2af9d490fec23a54$var$load("9S9Mz"),
    $2af9d490fec23a54$var$load("kiGNy"),
    $2af9d490fec23a54$var$load("7do1E"),
    $2af9d490fec23a54$var$load("77dkW"),
    $2af9d490fec23a54$var$load("1MlIV"),
    $2af9d490fec23a54$var$load("g9CVe"),
    $2af9d490fec23a54$var$load("7oiUM"),
    $2af9d490fec23a54$var$load("8t3po"),
    $2af9d490fec23a54$var$load("855o0"),
    $2af9d490fec23a54$var$load("8MfZE"),
    $2af9d490fec23a54$var$load("hv4mn"),
    $2af9d490fec23a54$var$load("dek7I"),
    $2af9d490fec23a54$var$load("dYtBN"),
    $2af9d490fec23a54$var$load("6wr18"),
    $2af9d490fec23a54$var$load("kjZZD"),
    $2af9d490fec23a54$var$load("8iA2F"),
    $2af9d490fec23a54$var$load("4RhJO"),
    $2af9d490fec23a54$var$load("jsqco"),
    $2af9d490fec23a54$var$load("851iy"),
    $2af9d490fec23a54$var$load("ffEVr"),
    $2af9d490fec23a54$var$load("dRpV3"),
    $2af9d490fec23a54$var$load("dTsOE"),
    $2af9d490fec23a54$var$load("hhss7"),
    $2af9d490fec23a54$var$load("jwTn5"),
    $2af9d490fec23a54$var$load("aYdgM"),
    $2af9d490fec23a54$var$load("6u1hm"),
    $2af9d490fec23a54$var$load("9vLZO"),
    $2af9d490fec23a54$var$load("hx8rI"),
    $2af9d490fec23a54$var$load("8fMw3"),
    $2af9d490fec23a54$var$load("hogcU"),
    $2af9d490fec23a54$var$load("aJAZ3"),
    $2af9d490fec23a54$var$load("7EorR"),
    $2af9d490fec23a54$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.ec6913e5.js.map
